export default __webpack_public_path__ + "static/media/HDTX_Risalah RUPS_Minutes of GMS 2021.b115db13.pdf";